import { useCallback, useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { InputBlock } from "./InputBlock";
import { useTextEditor } from "../../../components/textEditor/textEditor";
import { Spring } from "../../../components/spring/spring";
import { usePopup } from "../../../components/popup/popup";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { HTMLPreview } from "../../../components/htmlPreview/htmlPreview";
import { MediaSlider } from "../../../components/mediaSlider/mediaSlider";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import styles from "./addMaterial.module.css";
import { Scrollable } from "../../../components/scrollable/scrollable";

import { Text } from "../../../components/text/text";

export const SuperadminAddMaterialPage = () => {
    const { categoryId } = useParams();

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);

    const [media, setMedia] = useState([]);

    const [editor, toHtml] = useTextEditor();

    useEffect(() => {
        setNameError(false);
    }, [name]);

    const validateData = () => {
        let error = false;

        if (name.length <= 1 || name.length > 100) {
            setNameError(true);
            error = true;
        }

        return error;
    }

    const { cafeId } = useParams();
    const navigate = useAnimatedNavigate()
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const onSave = async () => {
        if (validateData()) return;

        const images = Array.from(media).filter(el => el.type.startsWith("image/"));
        const videos = Array.from(media).filter(el => el.type.startsWith("video/"));

        setError(false);
        setLoading(true);
        try {
            const res = await KnowledgeAPI.createEducationMaterial(categoryId, name, toHtml())

            console.log(res);
            if (media) {
                await Promise.all([...videos, ...images].map(async file => {
                    if (file.type.startsWith("image/"))
                        return KnowledgeAPI.addEducationMaterialImage(res.id, file);
                    else
                        return KnowledgeAPI.uploadMaterialVideo(res.id, file);
                }));
            }
            navigate(`/admin/${cafeId}/knowledge/${categoryId}`);

        } catch (err) {
            console.error(err);
            setError(true);
        }
        setLoading(false);
    }

    const [Popup, open] = usePopup();

    const [content, setContent] = useState(toHtml());
    const [previewMedia, setPreviewMedia] = useState([]);

    const revokePreviewMedia = useCallback(() => {
        previewMedia.forEach(url => {
            if (url?.src && url.src.startsWith('blob:')) {
                URL.revokeObjectURL(url.src);
            }
        });
    }, [previewMedia]);

    const onOpenDemo = () => {
        revokePreviewMedia();

        const images = Array.from(media).filter(el => el.type.startsWith("image/"));
        const videos = Array.from(media).filter(el => el.type.startsWith("video/"));

        const newUrls = [...videos, ...images].map(file => {
            if (file.type.startsWith("video/"))
                return {
                    type: "video",
                    src: URL.createObjectURL(file),
                };
            else
                return {
                    type: "image",
                    src: URL.createObjectURL(file),
                };
        });
        setPreviewMedia(newUrls);

        setContent(toHtml());
        open();
    }

    useEffect(() => {
        return revokePreviewMedia;
    }, [revokePreviewMedia]);

    return (
        <>
            <AdminHeader title="Добавить материал" />

            <InputBlock
                type="text"
                title="Введите название материала"
                value={name}
                setValue={setName}
                error={nameError}
            />

            <InputBlock
                type="files"
                title="Выберите изображения или видео для материала"
                value={media}
                setValue={setMedia}
                accept="image/*, video/*"
            />

            <InputBlock
                type="textEditor"
                title="Введите текст материала"
                editor={editor}
            />

            <Button
                type="secondary"
                text="Предпросмотр"
                onClick={onOpenDemo}
            />

            <Spring />

            <Button
                text="Добавить материал"
                onClick={onSave}
                disabled={loading}
                error={error}
            />

            <Popup style={{ height: "100%", maxHeight: "90dvh" }}>
                <Scrollable className={styles.preview}>
                    <Text as="div" variant="h1" className={styles.material_title} >{name}</Text>
                    {
                        previewMedia && previewMedia.length > 0 &&
                        <MediaSlider media={previewMedia} />
                    }
                    <HTMLPreview content={content} />
                </Scrollable>
            </Popup>
        </>
    )
}
